import { darken } from 'polished';
import styled from 'styled-components';
import { TextAreaAutoSizeProps } from './TextAreaAutoSize';
import { field } from '../panel';

export const Root = styled.textarea<TextAreaAutoSizeProps>`
  outline: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  transition: border 0.1s;
  resize: none;
  ${field};
  ${(p) => p.error && `border-color: ${p.theme.colors.general.error};`}
  background-color: ${(p) => (p.backgroundColorTone ? p.theme.colors.grey[p.backgroundColorTone] : 'transparent')};
  padding: 10px 12px;
  padding-left: ${(p) => (p.paddingLeft ? p.theme.spacing[p.paddingLeft] : '12px')};
  font-size: ${(p) => p.theme.font.size.sm};
  ${(p) =>
    p.borderColor &&
    `&:focus {
      border-color: ${darken(0.1, p.theme.colors.border[p.borderColor])}
  }`}

  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
`;
